import events from 'packages/alcumus-local-events'

export const getTour = events.return('get-tour')
export const getHelp = events.return('get-help')
